import PointsCalendar from './PointsCalendar';

export default PointsCalendar;